import { render, staticRenderFns } from "./HeadColumn.vue?vue&type=template&id=01f84e17&scoped=true"
import script from "./HeadColumn.vue?vue&type=script&lang=ts"
export * from "./HeadColumn.vue?vue&type=script&lang=ts"
import style0 from "./HeadColumn.vue?vue&type=style&index=0&id=01f84e17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f84e17",
  null
  
)

export default component.exports